import React from "react";
import styled, { device, themeGet, css } from "../../../styles";
import { Anchor } from "../../UI/Anchor";

export const StyledLoading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
`;
